import Store from 'store/store';
import { imageShareApi } from 'utils/bolt/api';
import { joinPaths, toQueryString } from 'utils/utils';

Store.on('CHANGE_ACTIVE_IMAGE', ({ image, pageId }) => {
	const gallery = Store.get().gallery;
	if (!gallery) Store.get().set({ gallery: {} });

	if (!pageId) {
		Store.get().gallery.set({ activeImage: image });
	} else {
		Store.get().gallery.set({
			[pageId]: {
				activeImage: image
			}
		});
	}
});

Store.on('GALLERY_SHARE_IMAGE', async ({ imageUrl, siteUrl, metaOverrides }) => {
	const shareBaseUrl = 'https://share.s-prod.pow.io/';
	const hash = await imageShareApi('generateHashFromQuery', { imageUrl, siteUrl, metaOverrides });
	const imageShareLink = shareBaseUrl + toQueryString({ imageUrl, siteUrl, metaOverrides, hash });
	if (typeof navigator?.share === 'function') {
		navigator.share({
			url: imageShareLink
		});
	} else {
		Store.get().gallery.set({
			imageShareLink
		});
	}
});

Store.on('CLOSE_GALLERY_SHARE', () => {
	Store.get().gallery.set({
		imageShareLink: false
	});
});
